import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { IMetalColor } from '../../core/IMetalColor';
import { IRalColorSelectedEvent } from '../ral-colorpicker/ral-colorpicker.component';
import { DataProviderService } from '../../core/data-provider.service';
import { IDataSource } from '../../core/IDataSource';
import { SpecialColorSelection } from '../SpecialColorSelection';

export interface IColorSelectedEvent {
    color: SpecialColorSelection;
}

type Categories = 'metal' | 'ral';

@Component({
    selector: 'plate-colorpicker',
    templateUrl: './plate-colorpicker.component.html',
    styleUrls: ['./plate-colorpicker.component.scss']
})
export class PlateColorpickerComponent implements OnInit {
    public selectedCategory: Categories = 'metal';
    public metalColorImgMap: { [labelRef: string]: string } = {
        ["metal-color-antique"]: require("./img/metal-color-antique.png"),
        ["metal-color-aranja"]: require("./img/metal-color-aranja.png"),
        ["metal-color-bronze"]: require("./img/metal-color-bronze.png"),
        ["metal-color-brushed-copper"]: require("./img/metal-color-brushed-copper.png"),
        ["metal-color-hansgrohe-black-chrome-brushed-340"]: require("./img/metal-color-hansgrohe-black-chrome-brushed-340.png"),
        ["metal-color-hansgrohe-bronze-brushed-140"]: require("./img/metal-color-hansgrohe-bronze-brushed-140.png"),
        ["metal-color-nickel-brushed"]: require("./img/metal-color-nickel-brushed.png"),
        ["metal-color-redgold-brushed"]: require("./img/metal-color-redgold-brushed.png"),
    };
    public metalColorsMap: { [id: number]: IMetalColor };
    public metalColorsArray: IMetalColor[];
    public metalColorsIdArray: string[];

    @Input()
    public selectedColor: SpecialColorSelection;

    @Input()
    public displayButton: boolean = true;

    @Input()
    public allowMattGlossySelection: boolean = false;

    @Input()
    public isMobileMode: boolean = false;

    private _isMetalColorSelectable: boolean = true;
    public get isMetalColorSelectable(): boolean {
        return this._isMetalColorSelectable;
    }

    @Input()
    public set isMetalColorSelectable(newValue: boolean) {
        this._isMetalColorSelectable = newValue;

        if (!newValue && this.selectedCategory === 'metal')
            this.selectedCategory = 'ral';
    }

    private _isRalColorSelectable: boolean = true;
    public get isRalColorSelectable(): boolean {
        return this._isRalColorSelectable;
    }

    @Input()
    public set isRalColorSelectable(newValue: boolean) {
        this._isRalColorSelectable = newValue;

        if (!newValue && this.selectedCategory === 'ral')
            this.selectedCategory = 'metal';
    }

    @Output()
    public colorSelected = new EventEmitter<IColorSelectedEvent>();

    @Output()
    public requestClose = new EventEmitter();

    constructor(private dataProvider: DataProviderService) {}

    public ngOnInit(): void {
        this.dataProvider.getData(true).subscribe(
            (data: IDataSource) => {
                this.metalColorsMap = data["metal-colors"];
                this.metalColorsArray = Object.values(this.metalColorsMap);
                this.metalColorsIdArray = Object.keys(this.metalColorsMap);
            }, console.error);
    }

    public selectMetalColor(metalColorId: number) {
        this.selectColor(SpecialColorSelection.fromMetalColor(metalColorId));
    }

    public selectRalColor(event: IRalColorSelectedEvent) {
        this.selectColor(SpecialColorSelection.fromRalColor(event.ralColor.ral, event.isMatt));
    }

    public selectColor(color: SpecialColorSelection) {
        this.colorSelected.emit({ color });
    }

    public toggleCategory() {
        if (this.selectedCategory === 'metal')
            this.setSelectedCategory('ral');
        else
            this.setSelectedCategory('metal');
    }

    public setSelectedCategory(newCategory: Categories) {
        this.selectedCategory = newCategory;
    }

    public requestClosePicker() {
        this.requestClose.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/plate-colorpicker/plate-colorpicker.component.ts